// extracted by mini-css-extract-plugin
export default {"Wrapper":"DialogBody_Wrapper__rQAcw","isLoading":"DialogBody_isLoading__0tm7I","Progress":"DialogBody_Progress__GaLMe"};